"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.complete.hero.title': '¡Bienvenido a IntHub!',
    'register.complete.hero.description': 'Su cuenta ha sido creada exitosamente. Por favor revise su correo electrónico para activar su cuenta.',
    'register.complete.email.check': 'Por favor revise su bandeja de entrada y haga clic en el enlace de activación para completar su registro.',
    'register.complete.login.button': 'Ir al inicio de sesión',
    'register.complete.home.button': 'Volver al inicio',
    'register.complete.help.text': '¿Necesita ayuda?',
    'register.complete.help.link': 'Contactar soporte',
    'register.complete.title': '¡Registro completado!',
    'register.complete.description': 'Gracias por registrarte en IntHub. Hemos enviado un correo de activación a tu dirección de correo registrada.',
    'register.complete.email.sent': 'Correo enviado a',
    'register.complete.button.login': 'Ir al Inicio de Sesión',
    'register.complete.button.resend': 'Reenviar Correo de Activación',
    'register.complete.help.check_spam': 'Por favor revise su carpeta de spam si no ve el correo en su bandeja de entrada.',
    'register.complete.help.contact_support': 'Si necesita asistencia, por favor contacte a nuestro equipo de soporte.',
    'register.complete.resend.success': '¡Correo de activación reenviado exitosamente!',
};
